module.exports = __webpack_public_path__ + "img/Group _27909.6c21fa41.svg";